interface Props {
  onButtonClick: (val: string) => void;
  onClear: () => void;
  onDelete: () => void;
  onCalculate: () => void;
  onMemorySave: () => void;
  onMemoryRecall: () => void;
  onMemoryAdd: () => void;
  onMemorySubtract: () => void;
}
const CalculatorButtons: React.FC<Props> = ({
  onButtonClick,
  onClear,
  onDelete,
  onCalculate,
  onMemorySave,
  onMemoryRecall,
  onMemoryAdd,
  onMemorySubtract,
}) => (
  <div className="buttons">
    <button className="btn special" onClick={onClear}>AC</button>
    <button className="btn special" onClick={onDelete}>C</button>
    <button className="btn operator" onClick={() => onButtonClick("%")}>%</button>
    <button className="btn operator" onClick={() => onButtonClick("/")}>/</button>

    {["7","8","9","*","4","5","6","+","1","2","3","-","00","0","."].map((btn) => (
      <button
        key={btn}
        className={`btn ${isNaN(Number(btn)) && btn !== "." ? "operator" : ""}`}
        onClick={() => onButtonClick(btn)}
      >
        {btn}
      </button>
    ))}

    <button className="btn equals" onClick={onCalculate}>=</button>
    <button className="btn memory-save" onClick={onMemorySave}>MS</button>
    <button className="btn memory-recall" onClick={onMemoryRecall}>MR</button>
    <button className="btn memory-add" onClick={onMemoryAdd}>M+</button>
    <button className="btn memory-subtract" onClick={onMemorySubtract}>M-</button>
  </div>
);
export default CalculatorButtons;
